import React, { useEffect } from "react";
import Typography from "@material-ui/core/Typography/Typography";
import { CenteredContainer } from "../../components/CenteredContainer/CenteredContainer";
import { BlueButton } from "../../components/Buttons/BlueButton";
import { useAuthContext } from "../../../auth/AuthProvider";

const LOGIN_TIMER_S = 15;

export interface ISaveUserDetailsSuccessViewProps {}

export const SaveUserDetailsSuccessView: React.FunctionComponent<ISaveUserDetailsSuccessViewProps> = () => {
    const authContext = useAuthContext();

    useEffect(() => {
        let timer = setTimeout(() => authContext.requestAuth(), LOGIN_TIMER_S * 1000);
        return () => {
            clearTimeout(timer);
        }
    }, [authContext])
    
    return (
        <CenteredContainer>
            <Typography variant="h3" gutterBottom>
                Your user details have been saved.
            </Typography>
            <Typography variant="h5" gutterBottom>
                You will be logged in automatically in a few seconds. Or you can log in by clicking the below button.
            </Typography>
            <BlueButton onClick={() => authContext.requestAuth()}>Log in</BlueButton>
        </CenteredContainer>
    );
};
